import React from 'react';

const IndicatorSVG = () => {
  return (
    <svg
      width='8'
      height='8'
      viewBox='0 0 8 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M-0.000151902 0.26704L7.62963 0.458026L4.02082 7.18309L-0.000151902 0.26704Z'
        fill='url(#paint0_linear_14693_38256)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_14693_38256'
          x1='1.79923'
          y1='0.377614'
          x2='4.56365'
          y2='5.1324'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#CC1313' />
          <stop offset='1' stopColor='#CC1313' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IndicatorSVG;
